"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useEventHandler_1 = require("../utils/useEventHandler");
/**
 * NsScroller component.
 * A React functional component that wraps its children within a custom HTML element <ns-scroller>.
 * Supports several properties and event handlers for customization.
 *
 * @param {NsScrollerProps} props - The properties for the NsScroller component.
 * @returns {JSX.Element} The rendered NsScroller component.
 */
var NsScroller = function (_a) {
    var hideScrollbar = _a.hideScrollbar, showControl = _a.showControl, type = _a.type, children = _a.children, onMoveScroller = _a.onMoveScroller, onScroll = _a.onScroll, rest = __rest(_a, ["hideScrollbar", "showControl", "type", "children", "onMoveScroller", "onScroll"]);
    var ref = react_1.default.useRef();
    (0, useEventHandler_1.useEventHandler)(ref, 'scroll', onScroll);
    (0, useEventHandler_1.useEventHandler)(ref, 'move-scroller', onMoveScroller);
    return (react_1.default.createElement("ns-scroller", __assign({ hideScrollbar: hideScrollbar, showControl: showControl, type: type, ref: ref }, rest), children));
};
exports.default = NsScroller;
